import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { CollegeContext } from '../context/CollegeContext';

const WaitListRoute = ({ children }) => {
    const {currentCollege} = useContext(CollegeContext);
    return currentCollege.inWaitlist==='true' ? <Navigate to="/waitlist" /> : children ;
}

export default WaitListRoute